import {
  NAME_INVALID_CHAR_PATTERN,
  PHONE_INVALID_CHAR_PATTERN,
  POSTAL_CODE_INVALID_CHAR_PATTERN,
} from '../../shared/validators/validator-pattern'
import { sanitizeRegistrationNumberInput as sanitizeRegisterNumber } from '../../shared/utils/registration-number'

const sanitizeInput = (event: Event, pattern: RegExp, maxLength?: number): string => {
  const input = event.target as HTMLInputElement
  let sanitized = input.value.replace(pattern, '')
  if (maxLength !== undefined) {
    sanitized = sanitized.substring(0, maxLength)
  }
  if (input.value !== sanitized) {
    input.value = sanitized
    input.dispatchEvent(new Event('input'))
  }
  return sanitized
}

/**
 * Composable for handling input restrictions on form fields
 */
export function useInputRestrictions() {
  const sanitizeNameInput = (event: Event): void => {
    sanitizeInput(event, NAME_INVALID_CHAR_PATTERN)
  }

  const sanitizePhoneInput = (event: Event): void => {
    sanitizeInput(event, PHONE_INVALID_CHAR_PATTERN)
  }

  const restrictPostalCodeInput = (event: Event): string => {
    return sanitizeInput(event, POSTAL_CODE_INVALID_CHAR_PATTERN, 5)
  }

  const sanitizeRegistrationNumberInput = (event: Event): void => {
    const input = event.target as HTMLInputElement
    const sanitized = sanitizeRegisterNumber(input.value)
    if (input.value !== sanitized) {
      input.value = sanitized
      input.dispatchEvent(new Event('input'))
    }
  }

  return {
    sanitizeNameInput,
    sanitizePhoneInput,
    restrictPostalCodeInput,
    sanitizeRegistrationNumberInput,
  }
}
